import { ArticleProps } from './Article';

export const DEFAULT_VALUES: ArticleProps = {
  authorImageUrl: 'https://cdn.zappy.app/8f151269c2bb9ba9e1b06a65fcd6f65c.png',
  authorName: 'Bryan Helmig',
  description:
    '<p>An automation mindset can help you use automation across your entire business, getting more done in less time</p>',
  imageUrl: 'https://cdn.zappy.app/f06d6d51b2788f4972912671fde3b6d2.jpeg',
  layout: 'card',
  title: 'Thinking with an automation mindset',
  url: '/blog/thinking-with-an-automation-mindset/',
};
